// Projects
export const GET_PROJECTS = 'GET_PROJECTS';
export const ADD_PROJECT = 'ADD_PROJECT';
export const RESET_PROJECTS = 'RESET_PROJECTS';
export const GET_PROJECTS_BY_ID = 'GET_PROJECTS_BY_ID';
export const PROJECT_REQUEST = 'PROJECT_REQUEST';
export const PROJECT_SUCCESS = 'PROJECT_SUCCESS';
export const PROJECT_FAILED = 'PROJECT_FAILED';

// General
export const REQUEST = 'REQUEST';
export const DONE = 'DONE';

// Equipments
export const GET_EQUIPMENTS = 'GET_EQUIPMENTS';
export const DELETE_EQUIPMENT = 'DELETE_EQUIPMENT';
export const RESET_EQUIPMENTS = 'RESET_EQUIPMENTS';
export const GET_EQUIPMENT_BY_ID = 'GET_EQUIPMENT_BY_ID';
export const GET_EQUIPMENTS_BY_EQUIPMENTNO = 'GET_EQUIPMENTS_BY_EQUIPMENTNO';
export const GET_EQUIPMENTS_BY_CONTRACT = 'GET_EQUIPMENTS_BY_CONTRACT';
export const GET_EQUIPMENTS_BY_SKNO = 'GET_EQUIPMENTS_BY_SKNO';
export const SEARCH_EQUIPMENT_BY_CONTRACT_NAME = 'SEARCH_EQUIPMENT_BY_CONTRACT_NAME';

// Logout
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';

// Register
export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';

// Verify
export const VERIFY_REQUEST = 'VERIFY_REQUEST';
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS';
export const VERIFY_FAIL = 'VERIFY_FAIL';
export const VERIFICATION_CODE_REQUEST = 'VERIFICATION_CODE_REQUEST';
export const VERIFICATION_CODE_SUCCESS = 'VERIFICATION_CODE_SUCCESS';
export const VERIFICATION_CODE_FAIL = 'VERIFICATION_CODE_FAIL';

export const GET_USERS = 'GET_USERS';
export const ADD_USER = 'ADD_USER';
export const RESET_USERS = 'RESET_USERS';
export const DELETE_USER = 'DELETE_USER';
export const GET_USER_BY_ID = 'GET_USER_BY_ID';
export const GET_USER_BY_QUERY = 'GET_USER_BY_QUERY';
export const GET_FILTERED_USERS = 'GET_FILTERED_USERS';
export const PASSWORD_CHANGE_REQUEST = 'PASSWORD_CHANGE_REQUEST';
export const PASSWORD_CHANGE_SUCCESS = 'PASSWORD_CHANGE_SUCCESS';
export const PASSWORD_CHANGE_FAIL = 'PASSWORD_CHANGE_FAIL';
export const AUTHORIZE_FAIL = 'AUTHORIZE_FAIL';
export const AUTHORIZE_SUCCESS = 'AUTHORIZE_SUCCESS';
export const SESSION_TIMED_OUT = 'SESSION_TIMED_OUT';

export const GET_SURVEYS = 'GET_SURVEYS';
export const GET_SURVEY_BY_ID = 'GET_SURVEY_BY_ID';
export const RESET_SURVEYS = 'RESET_SURVEYS';
export const DELETE_SURVEY = 'DELETE_SURVEY';

export const GET_TASKS = 'GET_TASKS';
export const GET_TASK_BY_QUERY = 'GET_TASK_BY_QUERY';
export const ADD_TASKS = 'ADD_TASKS';
export const RESET_TASKS = 'RESET_TASKS';
export const GET_TASKS_BY_ID = 'GET_TASKS_BY_ID';
export const GET_TASKS_BY_EQUIPMENTNO = 'GET_TASKS_BY_EQUIPMENTNO';
export const GET_TASKS_BY_SKNO = 'GET_TASKS_BY_SKNO';

export const GET_USER_ROLE = 'GET_USER_ROLE';

export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const RESET_NOTIFICATIONS = 'RESET_NOTIFICATIONS';

export const GET_ROLES = 'GET_ROLES';

export const GET_PROJECTROLES = 'GET_PROJECT_ROLES';
export const GET_PROJECTROLE_BY_ID = 'GET_PROJECTROLE_BY_ID';
export const DELETE_PROJECTROLE = 'DELETE_PROJECTROLE';
export const RESET_PROJECTROLES = 'RESET_PROJECTROLES';
export const GET_PROJECTROLES_BY_USERID = 'GET_PROJECTROLES_BY_USERID';
export const GET_PROJECTROLE_BY_QUERY = 'GET_PROJECTROLE_BY_QUERY';

export const GET_MATERIALS = 'GET_MATERIALS';
export const RESET_MATERIALS = 'RESET_MATERIALS';
export const GET_MATERIAL_BY_ID = 'GET_MATERIAL_BY_ID';
export const DELETE_MATERIAL = 'DELETE_MATERIAL';
export const ADD_MATERIAL = 'ADD_MATERIAL';

export const GET_LOCATIONS = 'GET_LOCATIONS';
export const RESET_LOCATIONS = 'RESET_LOCATIONS';
export const DELETE_LOCATION = 'DELETE_LOCATION';
export const GET_LOCATION_BY_ID = 'GET_LOCATION_BY_ID';
export const GET_LOCATION_BY_CODE = 'GET_LOCATION_BY_CODE';

export const GET_POOLS = 'GET_POOLS';
export const DELETE_POOL = 'DELETE_POOL';
export const RESET_POOLS = 'RESET_POOLS';
export const GET_POOL_BY_ID = 'GET_POOL_BY_ID';
export const GET_POOL_BY_QUERY = 'GET_POOL_BY_QUERY';

export const GET_SERVICEFIRMS = 'GET_SERVICEFIRMS';
export const RESET_SERVICEFIRMS = 'RESET_SERVICEFIRMS';
export const DELETE_SERVICEFIRM = 'DELETE_SERVICEFIRM';
export const GET_SERVICEFIRM_BY_ID = 'GET_SERVICEFIRM_BY_ID';

export const GET_CHECKLISTS = 'GET_CHECKLISTS';
export const RESET_CHECKLISTS = 'RESET_CHECKLISTS';
export const DELETE_CHECKLIST = 'DELETE_CHECKLIST';
export const GET_CHECKLIST_BY_ID = 'GET_CHECKLIST_BY_ID';

export const GET_SUPPORTS = 'GET_SUPPORTS';
export const RESET_SUPPORTS = 'RESET_SUPPORTS';
export const DELETE_SUPPORT = 'DELETE_SUPPORT';
export const GET_SUPPORT_BY_ID = 'GET_SUPPORT_BY_ID';

export const GET_QRCODES = 'GET_QRCODES';
export const GET_QRCODE_BY_ID = 'GET_QRCODE_BY_ID';
export const RESET_QRCODES = 'RESET_QRCODES';
export const DELETE_QRCODE = 'DELETE_QRCODE';

export const GET_EQUIPMENTTREES = 'GET_EQUIPMENTTREES';
export const RESET_EQUIPMENTTREES = 'RESET_EQUIPMENTTREES';
export const GET_EQUIPMENTTREES_BY_CODE = 'GET_EQUIPMENTTREES_BY_CODE';
export const GET_EQUIPMENTTREE_BY_ID = 'GET_EQUIPMENTTREE_BY_ID';

export const GET_JOBS = 'GET_JOBS';
export const ADD_JOBS = 'ADD_JOBS';
export const RESET_JOBS = 'RESET_JOBS';
export const GET_JOB_BY_ID = 'GET_JOB_BY_ID';
export const GET_JOBS_BY_EQUIPMENTNO = 'GET_JOBS_BY_EQUIPMENTNO';
export const GET_JOBS_BY_LOCATIONID = 'GET_JOBS_BY_LOCATIONID';

export const GET_WAREHOUSES = 'GET_WAREHOUSES';
export const ADD_WAREHOUSES = 'ADD_WAREHOUSES';
export const RESET_WAREHOUSES = 'RESET_WAREHOUSES';
export const GET_WAREHOUSE_BY_ID = 'GET_WAREHOUSE_BY_ID';

export const GET_PHOTOS = 'GET_PHOTOS';
export const DELETE_PHOTOS = 'DELETE_PHOTOS';
export const RESET_PHOTOS = 'RESET_PHOTOS';
export const GET_PHOTO_BY_ID = 'GET_PHOTO_BY_ID';
export const GET_PHOTOS_BY_QUERY = 'GET_PHOTOS_BY_QUERY';

export const GET_DOCUMENTS = 'GET_DOCUMENTS';
export const DELETE_DOCUMENTS = 'DELETE_DOCUMENTS';

export const GET_DASHBOARD_DAILY_STATISTICS_REQUEST = 'GET_DASHBOARD_DAILY_STATISTICS_REQUEST';
export const GET_DASHBOARD_DAILY_STATISTICS_FAILED = 'GET_DASHBOARD_DAILY_STATISTICS_FAILED';
export const GET_DASHBOARD_DAILY_STATISTICS_SUCCESS = 'GET_DASHBOARD_DAILY_STATISTICS_SUCCESS';
export const GET_DASHBOARD_WEEKLY_STATISTICS_REQUEST = 'GET_DASHBOARD_WEEKLY_STATISTICS_REQUEST';
export const GET_DASHBOARD_WEEKLY_STATISTICS_FAILED = 'GET_DASHBOARD_WEEKLY_STATISTICS_FAILED';
export const GET_DASHBOARD_WEEKLY_STATISTICS_SUCCESS = 'GET_DASHBOARD_WEEKLY_STATISTICS_SUCCESS';
export const GET_DASHBOARD_USERTASKS_REQUEST = 'GET_DASHBOARD_USERTASKS_REQUEST';
export const GET_DASHBOARD_USERTASKS_FAILED = 'GET_DASHBOARD_USERTASKS_FAILED';
export const GET_DASHBOARD_USERTASKS_SUCCESS = 'GET_DASHBOARD_USERTASKS_SUCCESS';
export const GET_DASHBOARD_MODAL_TASKS_REQUEST = 'GET_DASHBOARD_MODAL_TASKS_REQUEST';
export const GET_DASHBOARD_MODAL_TASKS_SUCCESS = 'GET_DASHBOARD_MODAL_TASKS_SUCCESS';
export const GET_DASHBOARD_MODAL_TASKS_FAILED = 'GET_DASHBOARD_MODAL_TASKS_FAILED';


export const GET_PAGES_REQUEST = 'GET_PAGES_REQUEST';
export const GET_PAGES_SUCCESS = 'GET_PAGES_SUCCESS';
export const GET_PAGES_FAILED = 'GET_PAGES_FAILED';
export const RESET_PAGES = 'RESET_PAGES';

export const GET_ROLES_REQUEST = 'GET_ROLES_REQUEST';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_FAILED = 'GET_ROLES_FAILED';
export const RESET_ROLES = 'RESET_ROLES';

export const GET_ROLE_PAGES_REQUEST = 'GET_ROLE_PAGES_REQUEST';
export const GET_ROLE_PAGES_SUCCESS = 'GET_ROLE_PAGES_SUCCESS';
export const GET_ROLE_PAGES_FAILED = 'GET_ROLE_PAGES_FAILED';
export const RESET_ROLE_PAGES = 'RESET_ROLE_PAGES';

export const GET_TENANTS = 'GET_TENANTS';
export const RESET_TENANTS = 'RESET_TENANTS';
export const GET_TENANT_BY_ID = 'GET_TENANT_BY_ID';
export const DELETE_TENANT = 'DELETE_TENANT';
export const ADD_TENANT = 'ADD_TENANT';
export const GET_TENANTS_BY_NO = 'GET_TENANTS_BY_NO';
export const GET_TENANTLIST_BY_ID = 'GET_TENANTLIST_BY_ID';
export const GET_TENANT_BY_Query = 'GET_TENANT_BY_Query';

export const GET_CUSTOMERS = 'GET_CUSTOMERS';
export const RESET_CUSTOMER = 'RESET_CUSTOMER';
export const DELETE_CUSTOMER = 'DELETE_CUSTOMER';
export const GET_CUSTOMER_BY_ID = 'GET_CUSTOMER_BY_ID';
export const GET_CUSTOMERS_BY_CODE = 'GET_CUSTOMERS_BY_CODE';

export const GET_CONTACTS = 'GET_CONTACTS';
export const RESET_CONTACT = 'RESET_CONTACT';
export const DELETE_CONTACT = 'DELETE_CONTACT';
export const GET_CONTACT_BY_ID = 'GET_CONTACT_BY_ID';

export const GET_CRM_INVOICES = 'GET_CRM_INVOICES';
export const RESET_CRM_INVOICE = 'RESET_CRM_INVOICE';
export const DELETE_CRM_INVOICE = 'DELETE_CRM_INVOICE';
export const GET_CRM_INVOICE_BY_ID = 'GET_CRM_INVOICE_BY_ID';

export const GET_LEADS = 'GET_LEADS';
export const RESET_LEAD = 'RESET_LEAD';
export const DELETE_LEAD = 'DELETE_LEAD';
export const GET_LEAD_BY_ID = 'GET_LEAD_BY_ID';
export const GET_INVOICE_BY_LEADID = 'GET_INVOICE_BY_LEADID';

export const GET_CREATETYPES = 'GET_CREATETYPES';
export const RESET_CREATETYPE = 'RESET_CREATETYPE';
export const DELETE_CREATETYPE = 'DELETE_CREATETYPE';

export const GET_CONTRACTS = 'GET_CONTRACTS';
export const RESET_CONTRACT = 'RESET_CONTRACT';
export const DELETE_CONTRACT = 'DELETE_CONTRACT';
export const GET_CONTRACT_BY_ID = 'GET_CONTRACT_BY_ID';
export const SEARCH_CONTRACT_BY_NAME = 'SEARCH_CONTRACT_BY_NAME';
export const SORT_BY_END_DATE = 'SORT_BY_END_DATE';


//Merchant
export const GET_MERCHANTS = 'GET_CUSTOMERS';
export const RESET_MERCHANT = 'RESET_CUSTOMER';
export const GET_MERCHANT_BY_ID = 'GET_CUSTOMER_BY_ID';
export const ADD_MERCHANT = 'AD_MERCHANT';

//Commission
export const GET_COMMISSIONS = 'GET_COMMISSIONS';
export const RESET_COMMİSSİON = 'RESET_COMMİSSİON';
export const GET_COMMİSSİON_BY_ID = 'GET_COMMİSSİON_BY_ID';

//Merchant and Transaction
export const GET_MERCTRANS = 'GET_MERCTRANS';
export const GET_MERCHANT = 'GET_MERCTRAN';
export const GET_MERCTRANSBYID = 'GET_MERCTRANSBYID';

//Transaction
export const GET_TRANSACTİON = 'GET_TRANSACTİON';
export const RESET_TRANSACTION = 'RESET_TRANSACTION';

//Banks
export const GET_BANKS = 'GET_BANKS';
export const RESET_BANK = 'RESET_BANK';
export const GET_BANK_BY_ID = 'GET_BANK_BY_ID';
export const GET_BANK_NAME_CHANNEL_NO = 'GET_BANK_NAME_CHANNEL_NO';
export const GET_BANK_COMMISSION_PROFILS = 'GET_BANK_COMMISSION_PROFILS';
export const GET_BANK_COMMISSION_PROFIL = 'GET_BANK_COMMISSION_PROFIL';

//Forms
export const GET_FORMS = 'GET_FORMS';
export const CREATE_FORMS_REQUEST = 'CREATE_FORMS_REQUEST';
export const CREATE_FORMS_SUCCESS = 'CREATE_FORMS_SUCCESS';
export const CREATE_FORMS_FAILED = 'CREATE_FORMS_FAILED';
export const GET_FORM_BY_ID = 'GET_FORM_BY_ID';
export const GET_FORMS_BY_USER_ID = 'GET_FORMS_BY_USER_ID';
export const UPDATE_FORMS_BY_USER_ID = 'UPDATE_FORMS_BY_USER_ID';
export const DELETE_FORM_BY_ID = 'DELETE_FORM_BY_ID';

//Error
export const ERROR = 'ERROR';
export const RESET_ERROR = 'RESET_ERROR';



//Bins
export const GET_ALL_BANKS = 'GET_ALL_BANKS';
export const GET_BANKS_BIN_LIST = 'GET_BANKS_BIN_LIST';

// Kiosk Definitions
export const GET_KIOSK_DEFINITIONS = 'GET_KIOSK_DEFINITIONS';
export const GET_KIOSK_DEFINITION_BY_ID = 'GET_KIOSK_DEFINITION_BY_ID';

// Auth
export const GET_AUTHORIZED_PROJECT_AND_USER = 'GET_AUTHORIZED_PROJECT_AND_USER';
export const SET_AUTHORIZED_PROJECT_AND_USER = 'SET_AUTHORIZED_PROJECT_AND_USER';
export const AUTHORIZE_PROJECT_AND_USER_FAIL = 'AUTHORIZE_PROJECT_AND_USER_FAIL';

// Bin Profile Payment Channel
export const GET_BIN_PROFILE_PAYMENT_CHANNELS = 'GET_BIN_PROFILE_PAYMENT_CHANNELS';
export const GET_PAYMENT_CHANNELS = 'GET_PAYMENT_CHANNELS';
export const GET_ALL_BINS = 'GET_ALL_BINS';
export const GET_BINS_BY_ID = 'GET_BINS_BY_ID';
export const GET_SINGLE_BIN = 'GET_SINGLE_BIN';

// Profiles
export const GET_PROFILES = 'GET_PROFILES';